import React, { Suspense, useState, useEffect } from"react";
import WizardServices from"./WizardServices";
import ContactSummary from "./contactSummary";

export default function ContactWizardDetail(MainWizard: any) {

    const [save, setsave] = useState(false);
    const [unfield, setunfield] = useState(false);
    var [contactInfo, initContactInfo] = useState<any>([]);

    useEffect(() => {
        console.log(MainWizard.data.code)

        if(MainWizard.data.code){
            WizardServices.contactInfo(MainWizard.data.code).then((res) => {
                initContactInfo(res)

                if(contactInfo.kontactsAddresses.telephone2){
                    contactInfo.tele2 = true
                }else{
                    contactInfo.tele2 = false
                }

                
                if(contactInfo.kontactsAddresses.telephone3){
                    contactInfo.tele3 = true
                }else{
                    contactInfo.tele3 = false
                }

                
                if(contactInfo.kontactsAddresses.telephone4){
                    contactInfo.tele4 = true
                }else{
                    contactInfo.tele4 = false
                }

                initContactInfo(contactInfo)
                
            })
        }

    }, []);

    const handleFieldChange = (e :any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;       
        
        console.log( Field_value)
        console.log( Field_type)
        if( Field_type === "checkbox"){
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');
        
        let updatedObject = { ...contactInfo };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        } 

        console.log(updatedObject);
        initContactInfo(updatedObject);
    };
    
    const saveCreator = () =>{
        console.log(contactInfo)
        WizardServices.kontactSave(contactInfo , {}) .then((res) => { setsave(true) });    
        setTimeout(function(){
            setsave(false); 
        }, 3000);    
    }

    const clearSForm = () =>{
        initContactInfo([])
    }      

    return (
        <div className="ws-12">

            <div className="w-65 ps">
                <div className="box">
                    <div className="box-header"> <h1>Contact Details</h1> </div>

                    <div className="box-content">
 
                        <div className="ws-12">

                            <div className="form-format">
                                <label className="control-label">Telephone</label>
                                <div className="label-entries">
                                    <div className="w-90">
                                        <input type="text" id="phone" name="kontactsAddresses.telephone" onChange={(e) =>handleFieldChange(e)}
                                        value={contactInfo && contactInfo.kontactsAddresses && contactInfo.kontactsAddresses.telephone ? contactInfo.kontactsAddresses.telephone:""}
                                        placeholder="Enter telephone" />
                                    </div>

                                    <div className="w-5">
                                        <div className="verticalMediumWide hover-box text-center pull-left">
                                            <ul className="hover-block" style={{width:"8vw"}}>
                                                <li className="hover-box text-left">
                                                    <input type="checkbox" onClick={(e) =>handleFieldChange(e)} name="tele2" value={contactInfo.tele2} checked={contactInfo.tele2} />
                                                        Telephone 2
                                                </li>

                                                <li className="hover-box text-left">
                                                    <input type="checkbox" onClick={(e) =>handleFieldChange(e)} name="tele3" value={contactInfo.tele3}  checked={contactInfo.tele3} />
                                                        Telephone 3
                                                </li>

                                                <li className="hover-box text-left">
                                                    <input type="checkbox" onClick={(e) =>handleFieldChange(e)} name="tele4" value={contactInfo.tele4}  checked={contactInfo.tele4} />
                                                        Telephone 4
                                                </li>
                                            </ul>
                                            <button className="icon-btn primary"> <i className="icon-add-solid"></i> </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="label-entries">
                                {(contactInfo.tele2 === "true" || contactInfo.tele2 === true) && <input type="text" name="kontactsAddresses.telephone2" className="mb mt w-90" 
                                    onChange={(e) =>handleFieldChange(e)} placeholder="Enter telephone 2"
                                    value={contactInfo && contactInfo.kontactsAddresses && contactInfo.kontactsAddresses.telephone2 ? contactInfo.kontactsAddresses.telephone2:""}/>}

                                {(contactInfo.tele3 === "true" || contactInfo.tele3 === true) && <input type="text"  name="kontactsAddresses.telephone3" className="mb mt w-90" 
                                    placeholder="Enter telephone 3" onChange={(e) =>handleFieldChange(e)}
                                    value={contactInfo && contactInfo.kontactsAddresses && contactInfo.kontactsAddresses.telephone3 ? contactInfo.kontactsAddresses.telephone3:""}/>}

                                {(contactInfo.tele4 === "true" || contactInfo.tele4 === true) && <input type="text" name="kontactsAddresses.telephone4" className="mb mt w-90" 
                                    placeholder="Enter telephone 4" onChange={(e) =>handleFieldChange(e)}
                                    value={contactInfo && contactInfo.kontactsAddresses && contactInfo.kontactsAddresses.telephone4 ? contactInfo.kontactsAddresses.telephone4:""}/>}
                            </div>

                            <div className="form-format">
                                <label className="control-label" >Main Fax</label>

                                <div className="label-entries">
                                    <input type="text"  id="faxNumber" placeholder="Main Fax" onChange={(e) =>handleFieldChange(e)} name="kontactsAddresses.faxNumber" 
                                    value={contactInfo && contactInfo.kontactsAddresses && contactInfo.kontactsAddresses.faxNumber ? contactInfo.kontactsAddresses.faxNumber:0}/>
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label" >Website</label>

                                <div className="label-entries">
                                    <input  type="text"  id="websiteURL" onChange={(e) =>handleFieldChange(e)} name="websiteURL" 
                                            value={contactInfo && contactInfo.websiteURL ? contactInfo.websiteURL:""} placeholder="Website"/>
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label" >Vendor Code</label>
                                <div className="label-entries">
                                    <input  type="text" id="vatRate" onChange={(e) =>handleFieldChange(e)} name="vendorCode"  
                                            value={contactInfo && contactInfo.vendorCode ? contactInfo.vendorCode:""} placeholder="Vendor Code" />
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label">Database</label>

                                <div className="label-entries">
                                    <select id="databaseCode" onChange={(e) =>handleFieldChange(e)} name="databaseCode"
                                        value={contactInfo && contactInfo.databaseCode ? contactInfo.databaseCode:""} >
                                        <option value="" >Choose your Database</option>
                                        <option value="UK" label="UK">UK</option>
                                        <option value="US" label="US">US</option>
                                        <option value="Mix" label="Mix">Mix</option>
                                    </select>
                                </div>

                            </div>

                            <div className="form-format ws-6">
                                <div className="form-format">
                                    <label className="control-label" >Tax Number</label>

                                    <div className="label-entries">
                                        <input type="text" id="vatNumber" onChange={(e) =>handleFieldChange(e)} name="vatNumber"  
                                                value={contactInfo && contactInfo.vatNumber ? contactInfo.vatNumber:""}  placeholder="Tax Number" />
                                    </div>
                                </div>
                            </div>

                            <div className="form-format ws-5">
                                <div className="form-format">
                                    <label className="control-label">Tax Rate%</label>

                                    <div className="label-entries w-95">
                                        <input type="text" id="vatRate" onChange={(e) =>handleFieldChange(e)} name="vatRate"  
                                            value={contactInfo && contactInfo.vatRate ? contactInfo.vatRate:""} placeholder="Tax Rate%" />
                                    </div>
                                </div>

                            </div>

                            <div className="form-format ws-6">
                                <div className="form-format">
                                    <label className="control-label">Due Days</label>

                                    <div className="label-entries">
                                        <input type="number" id="dueDays" onChange={(e) =>handleFieldChange(e)} name="dueDays"  
                                                value={contactInfo && contactInfo.dueDays ? contactInfo.dueDays:""} placeholder="Due Days"/>
                                    </div>
                                </div>

                            </div>

                            <div className="form-format ws-5">
                                <div className="form-format">
                                    <label className="control-label" >Digital Number</label>

                                    <div className="label-entries w-95">
                                        <input type="text"  id="digitalNumber" onChange={(e) =>handleFieldChange(e)} name="digitalNumber" 
                                            value={contactInfo && contactInfo.digitalNumber ? contactInfo.digitalNumber:""} placeholder="Digital Number"/>
                                    </div>
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label ws-3">Digital Provider</label>

                                <div className="label-entries ws-1">
                                    <label className="switch">
                                        <input type="checkbox" checked={contactInfo.digitalOnly}value={contactInfo && contactInfo.digitalOnly ? contactInfo.digitalOnly:false} name="digitalOnly" />
                                        {contactInfo.digitalOnly ==1 && <span className="slider round text-left white pm pts" >Yes</span>}
                                        {contactInfo.digitalOnly !=1 &&  <span className="slider round text-right white pm pts sliderOff" >No</span>}
                                    </label>
                                </div>
                            </div>                            

                        </div>
                    
                    </div>     

                    <div className="box-footer">
                        <div className="pull-right">
                            <button className="icon-btn edit" onClick={()=>saveCreator()}> <i className="icon-save"></i> Save </button>                       
                            <button className="btn-pink"    onClick={()=>clearSForm()}>  <i className="icon-reload"></i> Reset </button>
                        </div>

                    </div>
                </div>
            </div>

            <div className="w-35 ps ">
                <ContactSummary data={contactInfo}/>
            </div>
        </div>
    )

}